import React from "react";

export default function EmailCampaign() {
  return (
    <div className="page">
      <h1>Email Campaign</h1>
      <p>Email campaign placeholder.</p>
    </div>
  );
}
